import * as React from "react";

function AppLogo() {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          fill="none"
          viewBox="0 0 40 40"
        >
            <rect width="40" height="40" fill="#22C55E" rx="20"></rect>
            <path
              fill="#fff"
              d="M18.8 22.96q0 1.48-.6 2.68-.6 1.18-1.84 1.88-1.22.68-3.12.68-2.66 0-4.06-1.44Q7.8 25.3 7.8 22.92v-9.2h1.8v9.26q0 1.74.92 2.7.94.96 2.82.96 1.3 0 2.1-.46.82-.48 1.2-1.3.38-.84.38-1.92v-9.24h1.78zm9.889-7.86q-1.14 0-2.06.4a4 4 0 0 0-1.56 1.14q-.64.74-.98 1.82-.34 1.06-.34 2.4 0 1.76.54 3.06.56 1.3 1.64 2 1.1.7 2.74.7.94 0 1.78-.16t1.64-.4v1.56q-.8.3-1.66.44-.84.14-2.02.14-2.18 0-3.64-.9t-2.2-2.56q-.72-1.66-.72-3.9 0-1.62.44-2.96a6.8 6.8 0 0 1 1.32-2.32 5.8 5.8 0 0 1 2.16-1.5q1.28-.54 2.94-.54 1.1 0 2.12.22t1.82.62l-.72 1.52q-.66-.3-1.48-.54a6.1 6.1 0 0 0-1.76-.24"
            >
            </path>
        </svg>
    );
}

export default AppLogo;
